<template>
  <div>
    <v-app-bar flat color="transparent">
      <v-toolbar-title>
        Settings
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn class="ml-5" icon @click="showSearch = !showSearch">
        <img src="@/assets/icons/search.svg" alt="">
      </v-btn>
    </v-app-bar>
    <div>
      <v-tabs v-model="tab">
        <v-tab>General</v-tab>
      </v-tabs>
      <div class="ma-4">
        <v-tabs-items v-model="tab">
          <v-tab-item>
            <v-form v-if="form" ref="form" @submit.prevent="saveSettings" style="max-width: 400px">
              <label class="text-field-label pl-4"> Support Email </label>
              <v-text-field
                flat solo rounded
                required
                background-color="grey lighten-3"
                class="mt-2"
                v-model="form.support_email"
              ></v-text-field>

              <v-btn :loading="form.$busy" type="submit" color="primary" depressed large class="mr-4" rounded>
                Save Settings
              </v-btn>

            </v-form>
          </v-tab-item>
        </v-tabs-items>
      </div>
    </div>
    <v-overlay absolute :value="loading" opacity="0.2">
      <v-progress-circular indeterminate color="primary" size="64"></v-progress-circular>
    </v-overlay>
    <v-snackbar v-model="snackbar.show" right>
      {{ snackbar.message }}
      <v-btn color="pink" text @click="snackbar.show = false">
        Ok
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import Setting from '@/models/Setting'
import Form from '@/utils/form'

export default {
  data () {
    return {
      tab: null,
      loading: false,
      form: null,
      snackbar: {
        show: false,
        message: null
      }
    }
  },

  methods: {
    async getSettings () {
      Setting.first().then(response => (this.form = new Form(response)))
    },

    async saveSettings () {
      this.form.$busy = true

      const settings = new Setting({
        support_email: this.form.support_email
      })

      await settings.save()

      this.form.$busy = false
      this.showSnackbar('Settings successfully saved!')
    },

    showSnackbar (message) {
      this.snackbar.message = message
      this.snackbar.show = true
    }
  },

  created () {
    this.getSettings()
  }
}
</script>
